// countdown.js - Christmas countdown timer for Shopify header
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  // Automatically get next Christmas (Dec 25)
  function getNextChristmas() {
    const now = new Date();
    let year = now.getFullYear();
    // If today is after Dec 25, count down to next year's Christmas
    if (now.getMonth() === 11 && now.getDate() > 25) {
      year += 1;
    }
    return new Date(`${year}-12-25T00:00:00`);
  }

  function updateTimer(el, endDate) {
    if (!endDate || isNaN(endDate.getTime())) {
      el.style.display = 'none';
      return;
    }

    function tick() {
      const now = new Date();
      const diff = Math.max(0, endDate - now);

      const seconds = Math.floor(diff / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      el.querySelector('[data-unit="days"]').textContent = days;
      el.querySelector('[data-unit="hours"]').textContent = pad(hours);
      el.querySelector('[data-unit="minutes"]').textContent = pad(minutes);
      el.querySelector('[data-unit="seconds"]').textContent = pad(secs);

      // When Christmas arrives 🎅
      if (diff <= 0) {
        el.classList.add('countdown-expired');
        const label = el.querySelector('.countdown-label');
        if (label) label.textContent = '🎁 Merry Christmas!';
        clearInterval(intervalID);
      }
    }

    tick();
    const intervalID = setInterval(tick, 1000);
    return intervalID;
  }

  function initCountdowns() {
    const timers = document.querySelectorAll('#site-countdown, #christmas-countdown');
    timers.forEach(function (el) {
      const christmasDate = getNextChristmas();
      updateTimer(el, christmasDate);

      // Optional close/dismiss button logic
      const closeBtn = el.querySelector('.countdown-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          el.style.display = 'none';
          try { localStorage.setItem('countdownClosed', '1'); } catch (e) {}
        });
        try {
          if (localStorage.getItem('countdownClosed') === '1') {
            el.style.display = 'none';
          }
        } catch (e) {}
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }
})();